<template>
  <div>
    <md-field :class="messageClass" class="fb-select">
      <label :for="uuid">{{label | token_replace(nid)}}</label>
      <md-select placeholder="- Select -" id="select-view"  :id="uuid" @md-selected="updateValue" v-model="value" :multiple="multiple">
      <!--<md-select id="select-view" :md-label="label | token_replace(nid)" :id="uuid" @md-selected="updateValue" v-model="value" :multiple="multiple"> -->

        <md-option
          v-bind:key="index"
          v-for="(option, index) in options"
          :value="option.value"
        >{{option.label}}</md-option>
        <md-option v-if="select.other" value="other">Other</md-option>
      </md-select>
      <span class="md-helper-text">{{ select.help_text | token_replace(nid)}}</span>
    </md-field>


    <div v-if="value == 'other' || value.indexOf('other') !== -1">
      <md-field>
        <label>{{ select.other_label | token_replace(nid)}}</label>
        <md-input v-model="other_text"></md-input>
      </md-field>
    </div>
    <md-field v-if="!this.valid" :class="messageClass" class="label-top">
      <span class="md-error">*Required.</span>
    </md-field>
  </div>
</template>
<script>
export default {
  name: "FbSelectView",
  props: ["select", "multiple", "valid", "validate", "uuid", "nid"],
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    }
  },
  mounted() {
    this.$emit("md-selected", {
      value: this.value,
      other_text: this.other_text
    });
    this.$el.querySelector('input.md-input-fake').setAttribute('aria-label', this.select.label);
    this.$el.querySelector('select').append(document.createElement('option'));
    },
  data() {
    return {
      label: this.select.label,
      value: this.select.value.value || (this.multiple ? [] : ""),
      options: this.select.options.map(option => {
        return Object.assign({}, option);
      }),
      other_text: this.select.value.other_text || ""
    };
  },
  methods: {
    updateValue(val) {
      this.$emit("md-selected", {
        value: val,
        other_text: this.other_text
      });
    }
  },
  watch: {
    select: function(val) {
      this.label = val.label;
      this.options = val.options.map(option => {
        return Object.assign({}, option);
      });
      this.value = this.select.options
        .filter(option => {
          if (option.checked) {
            return true;
          }
        })
        .map(option => {
          return option.value;
        });
    },
    other_text: function(val) {
      this.$emit("md-selected", {
        value: this.value,
        other_text: val
      });
    }
  }
};
</script>
